import { forwardRef } from "react";
import * as React from "react";
import cn from "classnames";
import { useModalContext } from "../modal-context";

export interface ModalFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  /** className to be appended to the classnames for the top level element */
  className?: string;
}

const ModalFooter = forwardRef<HTMLDivElement, ModalFooterProps>(
  ({ children, className, ...rest }, ref) => {
    const { getBlocksWith } = useModalContext();

    return (
      <div
        className={cn(className, getBlocksWith("__footer"))}
        data-auto="modal-footer"
        ref={ref}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

export default ModalFooter;
